import { compact } from 'lodash-es';
import { serviceTemplateModel, serviceModel } from '~/models';
export class QboIntegrationPolicy {
    checkServiceMapping(param) {
        let { item, serviceTemplates, accounting } = param;
        var _ref;
        var _serviceTemplates_find_bundle, _serviceTemplates_find, _item_subItems;
        const serviceTemplate = item.serviceTemplateId ? serviceTemplates.find((st)=>st.id === item.serviceTemplateId) : undefined;
        const itemLinked = !serviceTemplate || serviceTemplateModel.integratedId({
            serviceTemplate,
            accounting
        });
        if (!itemLinked) return false;
        const bundleServices = item.serviceTemplateId ? (_serviceTemplates_find = serviceTemplates.find((st)=>st.id === item.serviceTemplateId)) === null || _serviceTemplates_find === void 0 ? void 0 : (_serviceTemplates_find_bundle = _serviceTemplates_find.bundle) === null || _serviceTemplates_find_bundle === void 0 ? void 0 : _serviceTemplates_find_bundle.services : undefined;
        return (_ref = (_item_subItems = item.subItems) === null || _item_subItems === void 0 ? void 0 : _item_subItems.every((subItem)=>{
            var _subItem_origin;
            const subTemplate = ((_subItem_origin = subItem.origin) === null || _subItem_origin === void 0 ? void 0 : _subItem_origin.serviceBundle.serviceTemplateId) ? [
                ...serviceTemplates,
                ...bundleServices || []
            ].find((s)=>{
                var _subItem_origin;
                return s.id === ((_subItem_origin = subItem.origin) === null || _subItem_origin === void 0 ? void 0 : _subItem_origin.serviceBundle.serviceTemplateId);
            }) : undefined;
            return !subTemplate || serviceTemplateModel.integratedId({
                serviceTemplate: subTemplate,
                accounting
            });
        })) !== null && _ref !== void 0 ? _ref : true;
    }
    checkContactsMapping(param) {
        let { contacts, relationship, accounting } = param;
        return contacts.some((c)=>c.id() === relationship.clientContactId && c.integratedId({
                accounting
            }));
    }
    getServiceTemplateIds(invoice) {
        const templateIds = [];
        invoice.items.forEach((item)=>{
            if (item.serviceTemplateId) {
                templateIds.push(item.serviceTemplateId);
            }
            if (item.subItems) {
                item.subItems.forEach((subItem)=>{
                    var _subItem_origin;
                    if ((_subItem_origin = subItem.origin) === null || _subItem_origin === void 0 ? void 0 : _subItem_origin.serviceBundle.serviceTemplateId) {
                        templateIds.push(subItem.origin.serviceBundle.serviceTemplateId);
                    }
                });
            }
        });
        return compact(templateIds);
    }
    getServiceTemplateIdsFromServices(services) {
        const templateIds = [];
        services.forEach((service)=>{
            var _service_bundle;
            templateIds.push(service.serviceTemplateId);
            if ((_service_bundle = service.bundle) === null || _service_bundle === void 0 ? void 0 : _service_bundle.services) {
                service.bundle.services.forEach((bundleService)=>{
                    if (bundleService.serviceTemplateId) {
                        templateIds.push(bundleService.serviceTemplateId);
                    }
                });
            }
        });
        return compact(templateIds);
    }
    getUnintegratedServices(services, accounting) {
        return services.filter((service)=>{
            var _service_bundle;
            const isServiceIntegrated = !!serviceModel.integratedId({
                service,
                accounting
            });
            if (!isServiceIntegrated) return true;
            if ((_service_bundle = service.bundle) === null || _service_bundle === void 0 ? void 0 : _service_bundle.services) {
                return service.bundle.services.some((bundleService)=>{
                    const bundleIntegratedId = bundleService.integrations.qboIntegratedId();
                    return !bundleIntegratedId;
                });
            }
            return false;
        });
    }
}
export class XeroIntegrationPolicy {
    checkServiceMapping(param) {
        let { item, serviceTemplates, accounting } = param;
        const serviceTemplate = item.serviceTemplateId ? serviceTemplates.find((st)=>st.id === item.serviceTemplateId) : undefined;
        return !serviceTemplate || !!serviceTemplateModel.integratedId({
            serviceTemplate,
            accounting
        });
    }
    checkContactsMapping(param) {
        let { contacts, relationship, accounting } = param;
        return contacts.some((c)=>c.id() === relationship.clientContactId && c.integratedId({
                accounting
            }));
    }
    getServiceTemplateIds(invoice) {
        return compact(invoice.items.map((item)=>item.serviceTemplateId));
    }
    getServiceTemplateIdsFromServices(services) {
        return compact(services.map((service)=>service.serviceTemplateId));
    }
    getUnintegratedServices(services, accounting) {
        return services.filter((service)=>!serviceModel.integratedId({
                service,
                accounting
            }));
    }
}
